<template>
  <div :ref="this.randomStr" class="svg-animated" v-html="this.svg" v-observe-visibility="{ callback: isInView, once: true, intersection: { threshold: 0.5 } }"></div>
</template>

<script>
// import SvgAnimated from "@/components/SvgAnimated";
import { TweenLite } from 'gsap';
import { DrawSVGPlugin } from 'DrawSVGPlugin';

export default {
  name: "SvgAnimated",
  props: {
    bgColor: String,
    image: String,
  },
  data() {
    return {
        svg: '',
    };
  },
  computed: {
    tl: function() { return new TimelineLite() },
    randomStr: function() { return [...Array(10)].map(i=>(~~(Math.random()*36)).toString(36)).join('') },
  },
  methods: {
    play() {
      const el = this.$refs[this.randomStr]
      const drawSVG = new DrawSVGPlugin()

      console.log('el', this.$el, this.$refs)

      const getNestedElements = (parent, cb, kids = []) => {
        const nextLayer = parent.children
        const hasKids = nextLayer && nextLayer.length ? true : false

        let lowestLevel = null
        if(hasKids) lowestLevel = [...nextLayer].filter(kid => kid.tagName !== 'g' && kid.tagName !== 'svg')
        if(lowestLevel) lowestLevel.forEach(kid => kids.push(kid))
        
        const notLowestLevel = hasKids && [...nextLayer].filter(kid => kid.tagName === 'g' || kid.tagName === 'svg')
        
        if(!notLowestLevel.length) {
          cb(kids)
        }
        
        return notLowestLevel.forEach(group => getNestedElements(group, cb, kids))
      }

      let paths = null
      getNestedElements(this.$el, result => paths = result)

      // this.tl.delay(2)
      TweenLite.set(this.$el, { opacity: '1' });
      this.tl.from(paths, 1, { drawSVG: 0, ease:Power1.easeInOut })
    },
    isInView(isVisible, entry) {
      if(isVisible)
        this.play()
    }
  },
  created() {
    this.svg = require(`../../public${this.image}`);
    console.log(this.image)
  },
};
</script>


<style lang="scss">
@import "../scss/settings.scss";

.svg-animated {
  transition: opacity 1s;
  width: 10%;
  opacity: 0;

  // svg {
    > * {
      stroke: white;
      stroke-width: 5px;
    }
  // }
}
</style>
